import React, { useEffect, useState } from "react";
import api, { getApiErrorMessage } from "../../api";
import EntryEditor from "./EntryEditor";
import FormField, { TextArea } from "../common/FormField";

export default function Proposals({ revision, contract, refs, onChanged }) {
  const [rows, setRows] = useState([]),
    [error, setError] = useState(""),
    [busy, setBusy] = useState(false),
    [selected, setSelected] = useState(null),
    [entry, setEntry] = useState(null),
    [reason, setReason] = useState("");
  const load = async () =>
    setRows((await api.get("/classifier/proposals")).data);
  useEffect(() => {
    load().catch((e) => setError(getApiErrorMessage(e)));
  }, []);
  const resolve = async (state, record, why) => {
    setBusy(true);
    setError("");
    try {
      await api.post(`/classifier/proposals/${selected.id}/resolve`, {
        state,
        record,
        revision_id: revision.id,
        revision: revision.revision,
        reason: why,
      });
      setEntry(null);
      setSelected(null);
      await load();
      await onChanged();
    } catch (e) {
      setError(getApiErrorMessage(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="classifier-panel classifier-stack">
      <h2>Предложения из аудитов</h2>
      <p>
        Локальная проверка не меняет библиотеку сама. Подготовьте её
        применимость и сохраните в выбранном черновике; публикация выполняется
        отдельно.
      </p>
      {error && (
        <p className="classifier-error" role="alert">
          {error}
        </p>
      )}
      {rows.map((r) => (
        <article className="classifier-row" key={r.id}>
          <div>
            <h3>{r.content.content?.title}</h3>
            <p>
              Аудит № {r.audit_id} ·{" "}
              {r.state === "proposed"
                ? "Ожидает рассмотрения"
                : r.state === "accepted"
                  ? "Принято в черновик"
                  : "Отклонено"}
            </p>
            <p>{r.reason}</p>
          </div>
          {r.state === "proposed" && (
            <div className="classifier-actions">
              <button
                className="ap-button ap-button--secondary"
                disabled={busy || revision.state !== "draft"}
                onClick={() => {
                  const c = r.content.content;
                  setSelected(r);
                  setEntry({
                    kind: "requirement",
                    id: "C-" + crypto.randomUUID(),
                    status: "active",
                    data: {
                      title: c.title,
                      requirement: c.requirement,
                      actions: c.actions,
                      criterion: c.criterion,
                      evidence: c.evidence,
                      severity: c.severity,
                      scope: "process",
                      process_binding: "fixed",
                      process_id: c.process_id,
                      condition: { process_required: c.process_id },
                      stages: [],
                      stage_policy: "none",
                      procedure_policy: "standard",
                    },
                  });
                }}
              >
                Подготовить требование
              </button>
              <button
                className="ap-button ap-button--secondary"
                disabled={busy}
                onClick={() => {
                  setSelected(r);
                  setReason("");
                }}
              >
                Отклонить
              </button>
            </div>
          )}
        </article>
      ))}
      {!rows.length && (
        <p className="classifier-notice">
          Предложений пока нет. Их можно отправить при добавлении дополнительной
          проверки в аудит.
        </p>
      )}
      {selected && !entry && (
        <div className="classifier-panel classifier-stack">
          <h3>Причина отклонения: {selected.content.content?.title}</h3>
          <FormField label="Обоснование">
            <TextArea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </FormField>
          <div className="classifier-actions">
            <button
              disabled={busy || !reason.trim()}
              className="ap-button ap-button--secondary"
              onClick={() => resolve("rejected", null, reason)}
            >
              Подтвердить отклонение
            </button>
            <button
              className="ap-button ap-button--secondary"
              onClick={() => setSelected(null)}
            >
              Отмена
            </button>
          </div>
        </div>
      )}
      {entry && (
        <EntryEditor
          entry={entry}
          kind="requirement"
          spec={contract.tables.requirement}
          refs={refs}
          busy={busy}
          error={error}
          onClose={() => {
            setEntry(null);
            setSelected(null);
          }}
          onSave={(record, why) => resolve("accepted", record, why)}
        />
      )}
    </section>
  );
}
